var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.is_sort),
      expression: "!is_sort"
    }]
  }, [_c('el-row', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('el-button', {
    staticStyle: {
      "background-color": "#006E4B",
      "color": "#FFFFFF",
      "border": "1px #006E4B solid",
      "font-size": "17px",
      "padding": "10px 20px"
    },
    on: {
      "click": _vm.AddDepartmentFrom
    }
  }, [_vm._v("\n                    添加子部门")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "background-color": "#006E4B",
      "color": "#FFFFFF",
      "border": "1px #006E4B solid",
      "font-size": "17px",
      "padding": "10px 20px",
      "width": "127px"
    },
    on: {
      "click": _vm.DepartmentSort
    }
  }, [_vm._v("\n                    排序")])], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "header-cell-style": {
        background: '#F0F0F0',
        color: '#000000'
      },
      "row-class-name": _vm.tableRowClassName,
      "data": _vm.tableData,
      "tooltip-effect": "dark",
      "height": "520"
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "序号",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope_1) {
        return [_vm._v(_vm._s(scope_1.$index + 1))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "project_name",
      "align": "center",
      "label": "部门名称"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm.condition.flag == 'plate' ? scope.row.project_name : scope.row.organize_name) + "\n                        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "organize_number",
      "align": "center",
      "label": "部门人数"
    }
  })], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-top": "10px",
      "text-align": "center"
    }
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "page-size": _vm.page_size,
      "layout": " prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.is_sort),
      expression: "is_sort"
    }]
  }, [_c('sort', {
    ref: "sort",
    on: {
      "Return": _vm.sortReturn
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "center": "",
      "visible": _vm.dialogVisible,
      "width": "30%",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("添加部门")])]), _vm._v(" "), _c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.from,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "部门名称",
      "prop": "project_name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入部门名称"
    },
    model: {
      value: (_vm.from.project_name),
      callback: function($$v) {
        _vm.$set(_vm.from, "project_name", $$v)
      },
      expression: "from.project_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "部门主管",
      "prop": "staff_ids"
    }
  }, [_c('div', {
    on: {
      "click": _vm.setStaff
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "点击设置部门主管",
      "onfocus": "this.blur();"
    },
    model: {
      value: (_vm.from.staff_name),
      callback: function($$v) {
        _vm.$set(_vm.from, "staff_name", $$v)
      },
      expression: "from.staff_name"
    }
  })], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "上级部门"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.from.organize_name),
      callback: function($$v) {
        _vm.$set(_vm.from, "organize_name", $$v)
      },
      expression: "from.organize_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "label-width": "0"
    }
  }, [_c('el-button', {
    staticStyle: {
      "background-color": "#006E4B",
      "border": "1px #006E4B solid",
      "width": "100px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.AddDepartment
    }
  }, [_vm._v("保存")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "width": "40%",
      "center": "",
      "visible": _vm.setStaffVisible,
      "append-to-body": "",
      "close-on-click-modal": false,
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.setStaffVisible = $event
      }
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("设置部门主管")])]), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "border": "1px solid #EBEEF5"
    }
  }, [_c('setStaff', {
    ref: "setStaff",
    attrs: {
      "type": "checkbox",
      "accordion": false,
      "staff_ids_prop": _vm.from.staff_ids
    },
    on: {
      "commit": _vm.saveChange
    }
  })], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "goon"
    },
    on: {
      "click": function($event) {
        return _vm.$refs['setStaff'].commit()
      }
    }
  }, [_vm._v("确定")])], 1)], 2)], 2)], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3368a595","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/jcrsgl/Jtzzjggl/Jtzzjggl_department.vue
// module id = null
// module chunks = 